import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
import { useAnimatedCounter } from '../../hooks/useAnimatedCounter';

interface StatCounterProps {
  target: number;
  prefix?: string;
  suffix?: string;
  /** Final display override (e.g. '5-15%', 'LOWEST'). */
  display?: string;
  className?: string;
}

/**
 * Reusable animated number counter.
 * Starts counting when the element scrolls into view.
 */
export function StatCounter({ target, prefix = '', suffix = '', display, className = '' }: StatCounterProps) {
  const [ref, isVisible] = useIntersectionObserver<HTMLSpanElement>({ threshold: 0.3 });
  const text = useAnimatedCounter({ target, prefix, suffix, display, enabled: isVisible });

  return (
    <span ref={ref} className={`stat-number ${className}`}>
      {text}
    </span>
  );
}
